import { faArrowRight, faBars, faFilePdf, faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { Badge, Button, Card, Col, Container, Form, Row, Spinner } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { ReactSortable } from 'react-sortablejs';
import { toast } from 'react-toastify';
import { POST } from '../../api';
import examTitleIcon from '../../assets/images/exam.png';
import examNote from '../../assets/images/info-slim-yellow.png';
import qlClose from '../../assets/images/question-list-close.png';
import qlOpen from '../../assets/images/question-list-open.png';
import timeLeft from '../../assets/images/wall-clock-red.png';
import { withParams } from '../../helpers/params_helper';
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper';
import { t } from '../../helpers/translation_helper';
import './ck-editor.css';
import './exams.css';
import { handleFormErrors } from '../../helpers/form_helpers';

// API URL
const apiURL = process.env.REACT_APP_API_URL;

// Portal URL
const portalURL = process.env.REACT_APP_PORTAL_URL;

/**
 * Attempt Exam Component
 */
class AttemptExam extends Component {
    // State
    state = {
        examDetails: null,
        examLocked: null,
        ExamAnswers: [],
        shouldRedirect: false,
        working: false,
        qListPanel: false,
        QsNums: [],
        examConfirm: {
            show: false,
            action: () => { }
        }
    };

    /**
     * Constructor
     */
    constructor() {
        super();
        this.qList = React.createRef();
        this.qListNums = React.createRef();
    }

    /**
     * Component Did Mount
     */
    componentDidMount() {
        this.getExamDetails();
    }

    /**
     * Get Exam Details
     */
    getExamDetails = async () => {
        const { authData } = this.props;
        const { auth_key } = authData.loginData;
        const { center_id, center_timezone } = authData.centerData;
        const { selectedChild, params } = this.props;
        const { exams_id, exam_retake_id } = params;

        const fData = new FormData();

        fData.append('exams_id', exams_id);
        fData.append('class_id', selectedChild.class_id);
        fData.append('child_id', selectedChild.child_id);
        fData.append('parent_id', selectedChild.parent_id);
        fData.append('exam_retake_id', exam_retake_id == 0 ? null : exam_retake_id);

        try {
            const req = await POST('exam-attempt/get-exam-details',
                fData,
                {
                    params: {
                        auth_key: auth_key,
                    },
                }
            );

            if (req.data.type) {
                const ExamAnswers = [];
                const QsNums = [];

                const RemoteExamAnswers = req.data.data.ExamAnswers;
                // Create Answers
                req.data.data.Examsquest.map((item, index) => {
                    if (item.examsquesttype.eqtype_id == 9) {
                        return false;
                    }
                    let foundAnswer = RemoteExamAnswers.find((foundAnswerItem) => foundAnswerItem.examsquest_id == item.examsquest_id);
                    ExamAnswers.push({
                        exam_ans_id: 0,
                        center_id: center_id,
                        child_id: selectedChild.child_id,
                        parent_id: selectedChild.parent_id,
                        class_id: item.class_id,
                        examsquest_id: item.examsquest_id,
                        exams_id: item.exams_id,
                        answer: null,
                        attachment: null,
                        examsquest_duration: 0,
                        is_time_over: 0,
                        answer_grade: 0,
                        is_correct: '',
                        checked_by_employee: null,
                        checked_by_datetime: null,
                        confirmed_answer_grade: 0,
                        examAns: [],
                        eqtype_id: item.examsquesttype.eqtype_id,
                        ...foundAnswer,
                    });

                    QsNums.push({
                        qid: item.examsquest_id,
                        status: (foundAnswer && (foundAnswer.answer || foundAnswer.attachment || foundAnswer.examAns.length > 0)) ? 'attempted' : 'unattempted',
                    });
                });

                this.setState({
                    examDetails: req.data.data,
                    ExamAnswers,
                    examLocked: null,
                    QsNums,
                });
            } else {
                this.setState({
                    examLocked: {
                        message: req.data.message,
                        messageTitle: req.data.messageTitle,
                    },
                });
            }
        } catch (err) {
            toast.error('Something went wrong while fetching exam data!');
            console.log(err);
        }
    };

    /**
     * Render Exam Questions
     * @returns {HTMLElement}
     */
    renderExamQs = () => {
        const { examDetails, ExamAnswers } = this.state;
        const { Examsquest } = examDetails;

        const questions = Examsquest.map((item, index) => {
            // Exclude if the question is Audio Recording
            if (item.examsquesttype.eqtype_id == 9) {
                return false;
            }

            return (
                <Card
                    key={index}
                    className='mb-4 border-0'
                    id={'q-' + item.examsquest_id}>
                    <Card.Body>
                        <div className='q-card-header '>
                            <div className='q-type ps-0 pb-2' style={{ fontSize: 14, flex: 1, fontWeight: 600 }}>
                                {index + 1}. {item.examsquesttype.eqtype_name}
                            </div>
                            <div className='d-flex justify-content-end pe-0 pb-2' style={{ fontSize: 12, flex: 1 }}>
                                <button
                                    onClick={() =>
                                        this.updateQNumStatus(
                                            index,
                                            'attemptlater'
                                        )
                                    }
                                    className='pe-2 ps-2 me-2 mark-attempt-later-btn'>
                                    {t('Mark as attempt later')}
                                </button>
                                <div
                                    className='badge badge-outline-primary me-2 d-flex align-items-center'>
                                    {t('Marks:') + ' ' + item.examsquest_grade}
                                </div>
                                {/* <Badge
                                    bg='warning'
                                    text='dark'
                                    className='me-2 d-flex align-items-center'>
                                    {t('Time:') +
                                        ' ' +
                                        item.examsquest_duration}
                                </Badge> */}
                                <div className={(item.is_mandatory == 1) ? 'badge badge-outline-danger d-flex align-items-center' : 'badge badge-outline-success d-flex align-items-center'}>
                                    {t('Mandatory:') +
                                        ' ' +
                                        (item.is_mandatory == 1
                                            ? t('Yes')
                                            : t('No'))}
                                </div>
                            </div>
                        </div>
                        <div
                            className='ck-content my-2'
                            dangerouslySetInnerHTML={{
                                __html: item.examsquest_desc1.replaceAll(
                                    '<input/>',
                                    '<input class="fitb fitb-' +
                                    item.examsquest_id +
                                    '" />'
                                ),
                            }}
                        />
                        {/* ATTACHMENTS */}
                        <div className='d-flex flex-row flex-wrap'>
                            {item.examsquest_file1 &&
                                <div className='cursor-pointer my-2' onClick={() => window.open(getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/examsquest/' + item.examsquest_file1)}>
                                    {item.examsquest_file1.includes('pdf') &&
                                        <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 60 }} />
                                    }
                                    {!item.examsquest_file1.includes('pdf') &&
                                        <img src={getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/examsquest/' + item.examsquest_file1} alt={t('Preview')} style={{ height: 80 }} />
                                    }
                                </div>
                            }
                        </div>
                        {this.examQuestionOpts(
                            item.examsquesttype.eqtype_id,
                            item.examsquestoptions,
                            item.examsquest_id,
                            index,
                            ((ExamAnswers.length > 0)
                                ? ExamAnswers.find((found_item) => found_item.examsquest_id == item.examsquest_id)
                                : null),
                            item.maxCorrectOptions
                        )}
                    </Card.Body>
                </Card>
            );
        });

        return questions;
    };

    /**
     * Exam Question Options
     * @param {number} eqtype_id
     * @param {array} opts
     * @param {number} qid
     * @param {number} index
     * @returns
     */
    examQuestionOpts = (eqtype_id, opts, qid, index, answers, maxCorrectOptions = null) => {
        // MCQs
        if (eqtype_id == 1) {
            let qindex = index;
            let answer_exists = false;
            const qopts = opts.map((item, index) => {
                if (answers !== null) {
                    const find_answer = answers.examAns.findIndex(
                        (found_item) => {
                            return (
                                found_item.examsquestoptions_id_selected ==
                                item.examsquestoptions_id
                            );
                        }
                    );
                    answer_exists = find_answer !== -1 ? true : false;
                }
                return (
                    <div key={index} style={{ display: 'inline-block', marginRight: '15px', marginBottom: '10px' }}>
                        <Form.Check
                            inline
                            type='radio'
                            id={`default-${item.examsquestoptions_id}`}
                            name={`opt-${item.examsquest_id}`}
                            label={
                                <div>
                                    {item.option_text_picture && (
                                        <img
                                            src={`${getRegionalStorageURL(this.props.authData.centerData.tenant_id) + this.props.authData.centerData.center_uuid}/examsquestoptions/${item.option_text_picture}`}
                                            alt={item.option_text}
                                            style={{ maxWidth: '200px', maxHeight: '150px', display: 'block', marginBottom: '5px' }}
                                        />
                                    )}
                                    <div dangerouslySetInnerHTML={{ __html: item.option_text }} />
                                    {/* {item.option_text} */}
                                </div>
                            }
                            value={item.option_text}
                            data-id={item.examsquestoptions_id}
                            defaultChecked={answer_exists}
                            onClick={() =>
                                this.updateQNumStatus(qindex, 'attempted')
                            }
                        />
                    </div>
                );
            });

            return (
                <div key={`inline-radio`} className='mb-3'>

                    {qopts}
                </div>
            );
        }
        // MRQs
        if (eqtype_id == 2) {
            let qindex = index;
            let answer_exists = false;
            const qopts = opts.map((item, index) => {
                if (answers !== null) {
                    const find_answer = answers.examAns.findIndex(
                        (found_item) => {
                            return (
                                found_item.examsquestoptions_id_selected ==
                                item.examsquestoptions_id
                            );
                        }
                    );
                    answer_exists = find_answer !== -1 ? true : false;
                }

                return (
                    <div key={index} style={{ display: 'inline-block', marginRight: '15px', marginBottom: '10px' }}>
                        <Form.Check
                            inline
                            type='checkbox'
                            id={`opt-${item.examsquestoptions_id}`}
                            name={`opt-${item.examsquestoptions_id}`}
                            label={
                                <div>
                                    {item.option_text_picture && (
                                        <img
                                            src={`${getRegionalStorageURL(this.props.authData.centerData.tenant_id) + this.props.authData.centerData.center_uuid}/examsquestoptions/${item.option_text_picture}`}
                                            alt={item.option_text}
                                            style={{ maxWidth: '200px', maxHeight: '150px', display: 'block', marginBottom: '5px' }}
                                        />
                                    )}
                                    {/* {item.option_text} */}
                                    <div dangerouslySetInnerHTML={{ __html: item.option_text }} />
                                </div>
                            }
                            value={item.option_text}
                            data-id={item.examsquestoptions_id}
                            defaultChecked={answer_exists}
                            onClick={(e) =>
                                this.updateQNumStatus(qindex, 'attempted', e)
                            }
                        />
                    </div>
                );
            });

            return (
                <div key={`inline-checkbox`} className='mb-3'>
                    {qopts}
                    <div className='mt-2'>{'Please select ' + maxCorrectOptions + ' options'}</div>
                </div>
            );
        }
        // True False
        if (eqtype_id == 3) {
            let qindex = index;
            let answer_exists = false;
            const qopts = opts.map((item, index) => {
                if (answers !== null) {
                    const find_answer = answers.examAns.findIndex(
                        (found_item) => {
                            return (
                                found_item.examsquestoptions_id_selected ==
                                item.examsquestoptions_id
                            );
                        }
                    );
                    answer_exists = find_answer !== -1 ? true : false;
                }
                return (
                    <div key={index} style={{ display: 'inline-block', marginRight: '15px', marginBottom: '10px' }}>
                        <Form.Check
                            inline
                            type='radio'
                            id={`default-${item.examsquestoptions_id}`}
                            name={`opt-${item.examsquest_id}`}
                            label={
                                <div>
                                    {item.option_text_picture && (
                                        <img
                                            src={`${getRegionalStorageURL(this.props.authData.centerData.tenant_id) + this.props.authData.centerData.center_uuid}/examsquestoptions/${item.option_text_picture}`}
                                            alt={item.option_text}
                                            style={{ maxWidth: '200px', maxHeight: '150px', display: 'block', marginBottom: '5px' }}
                                        />
                                    )}
                                    {/* {item.option_text} */}
                                    <div dangerouslySetInnerHTML={{ __html: item.option_text }} />
                                </div>
                            }
                            value={item.option_text}
                            data-id={item.examsquestoptions_id}
                            defaultChecked={answer_exists}
                            onClick={() =>
                                this.updateQNumStatus(qindex, 'attempted')
                            }
                        />
                    </div>
                );
            });

            return (
                <div key={`inline-radio`} className='mb-3'>
                    {qopts}
                </div>
            );
        }

        // Brief Description
        if (eqtype_id == 4) {
            return (
                <Form.Control
                    as='textarea'
                    placeholder={t('Answer here')}
                    style={{ height: '100px' }}
                    id={`brief-desc-${qid}`}
                    defaultValue={answers ? answers.answer : ''}
                    onBlur={() => this.updateQNumStatus(index, 'attempted')}
                />
            );
        }

        // Detailed Description
        if (eqtype_id == 5) {
            return (
                <Form.Control
                    as='textarea'
                    placeholder={t('Answer here')}
                    style={{ height: '100px' }}
                    id={`brief-desc-${qid}`}
                    defaultValue={answers ? answers.answer : ''}
                    onBlur={() => this.updateQNumStatus(index, 'attempted')}
                />
            );
        }

        // Matching Words
        if (eqtype_id == 6) {
            let answer_options = null;

            if (answers !== null && answers.examAns.length > 0) {
                answer_options = answers.examAns;
            }

            return (
                <Row style={{}}>
                    <Col>
                        {opts.map((item, index) => (
                            <div key={index} className='d-flex flex-row'>
                                <div className='word-match-to d-flex flex-row justify-content-between align-items-center' style={{ width: '100%' }}>
                                    <div style={{ border: 'solid 1px #000', borderRadius: 30, padding: 5 }}>{(index + 1)}</div>
                                    <div className='d-flex flex-column ps-2' style={{ flex: 1 }}>
                                        {item.option_text_picture && (
                                            <div>
                                                <img
                                                    src={`${getRegionalStorageURL(this.props.authData.centerData.tenant_id) + this.props.authData.centerData.center_uuid}/examsquestoptions/${item.option_text_picture}`}
                                                    alt={item.option_text}
                                                    style={{ maxWidth: '200px', maxHeight: '150px', display: 'block', marginBottom: '5px' }}
                                                />
                                            </div>
                                        )}
                                        {/* <div className='mx-1'>{item.option_text}</div> */}
                                        <div className='mx-1' dangerouslySetInnerHTML={{ __html: item.option_text }} />
                                    </div>
                                </div>
                                <div
                                    style={{ height: '48px', }}
                                    className='d-flex justify-content-center align-items-center mx-2'>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </div>
                            </div>
                        ))}
                    </Col>
                    <Col>
                        <MatchingWords
                            opts={opts}
                            answerOptions={answer_options}
                            index={index}
                            updateMatchingWords={this.updateMatchingWords}
                            authData={this.props.authData}
                        />
                    </Col>
                </Row>
            );
        }

        // File Upload
        if (eqtype_id == 7) {
            const fileID = 'file-' + qid;
            return (
                <div style={{ maxWidth: '400px', textAlign: 'center' }}>
                    {answers && (
                        <img
                            src={`${getRegionalStorageURL(this.props.authData.centerData.tenant_id) + this.props.authData.centerData.center_uuid}/exam_answers/${answers.attachment}`}
                            alt=''
                            className='mb-3'
                            width='150'
                            height='auto'
                        />
                    )}
                    <Form.Control
                        type='file'
                        id={fileID}
                        onChange={(e) => {
                            this.uploadImage(e, qid, index);
                        }}
                    />
                </div>
            );
        }

        // Fill if the blank
        if (eqtype_id == 8) {
            var elements = document.getElementsByClassName('fitb-' + qid);

            for (var i = 0, len = elements.length; i < len; i++) {
                elements[i].value =
                    answers && answers.examAns.length > 0
                        ? answers.examAns[i].examsquestoption2
                        : '';
            }
        }
    };

    /**
     * Save Exam Attempt
     */
    saveExamAttempt = async (submitted = 0) => {
        this.setState({ working: true });
        const { examDetails, ExamAnswers } = this.state;
        const { Examsquest } = examDetails;
        const { authData } = this.props;
        const { auth_key } = authData.loginData;
        const { center_id, center_timezone } = authData.centerData;
        const { selectedChild, params } = this.props;
        const { exams_id, exam_retake_id } = params;
        const { class_id, child_id, parent_id } = selectedChild;

        let NewExamAnswers = ExamAnswers
        const fData = new FormData();
        Examsquest.map((item, index) => {
            //  MCQs | True / False
            if (item.examsquesttype.eqtype_id == 1 || item.examsquesttype.eqtype_id == 3) {
                if (
                    document.querySelector(
                        `input[name="opt-${item.examsquest_id}"]:checked`
                    )
                ) {
                    const id = document
                        .querySelector(
                            `input[name="opt-${item.examsquest_id}"]:checked`
                        )
                        .getAttribute('data-id');
                    const answer = document.querySelector(
                        `input[name="opt-${item.examsquest_id}"]:checked`
                    ).value;

                    NewExamAnswers[index].examAns = [
                        {
                            ans_detail_id: 0,
                            exam_ans_id: 0,
                            examsquestoptions_id_selected: id,
                            examsquestoption: answer,
                            examsquestoptions_id_selected2: null,
                            examsquestoption2: null,
                        },
                    ];
                }
            }

            // MRQ
            if (item.examsquesttype.eqtype_id == 2) {
                const mrq_answers = [];

                item.examsquestoptions.map((opt_item, opt_index) => {
                    const opt_id = opt_item.examsquestoptions_id;
                    if (document.querySelector(`#opt-${opt_id}:checked`)) {
                        const checkbox = document.querySelector(
                            `#opt-${opt_id}:checked`
                        );
                        mrq_answers.push({
                            ans_detail_id: 0,
                            exam_ans_id: 0,
                            examsquestoptions_id_selected:
                                checkbox.getAttribute('data-id'),
                            examsquestoption: checkbox.value,
                            examsquestoptions_id_selected2: null,
                            examsquestoption2: null,
                        });
                    }
                });

                NewExamAnswers[index].examAns = mrq_answers;
            }

            //  Brief Description | Detailed Description
            if (
                item.examsquesttype.eqtype_id == 4 ||
                item.examsquesttype.eqtype_id == 5
            ) {
                const answer = document.getElementById(
                    `brief-desc-${item.examsquest_id}`
                ).value;
                NewExamAnswers[index].answer = answer;
            }

            //  Fill In The Blank
            if (item.examsquesttype.eqtype_id == 8) {
                const fitb_answers = [];

                var elements = document.getElementsByClassName(
                    'fitb-' + item.examsquest_id
                );

                for (var i = 0, len = elements.length; i < len; i++) {
                    fitb_answers.push({
                        ans_detail_id: 0,
                        exam_ans_id: 0,
                        examsquestoptions_id_selected:
                            item.examsquestoptions[i].examsquestoptions_id,
                        examsquestoption: null,
                        examsquestoptions_id_selected2:
                            item.examsquestoptions[i].examsquestoptions_id,
                        examsquestoption2: elements[i].value,
                    });
                }
                NewExamAnswers[index].examAns = fitb_answers;
            }

            // if (item.examsquesttype.eqtype_id == 7 && NewExamAnswers[index].attachment && NewExamAnswers[index].attachment.name) {
            //     fData.append('attachment[' + item.examsquest_id + ']', NewExamAnswers[index].attachment, NewExamAnswers[index].attachment.name)
            // }
        });

        fData.append('exams_id', exams_id);
        fData.append('class_id', class_id);
        fData.append('child_id', child_id);
        fData.append('parent_id', parent_id);
        fData.append('center_id', center_id);
        fData.append('center_timezone', center_timezone);
        fData.append('submitted', submitted);
        fData.append('newExamAnswers', JSON.stringify(NewExamAnswers));

        try {
            const req = await POST('exam-attempt/save-exam-attempt',
                fData,
                {
                    params: {
                        auth_key: auth_key,
                    },
                }
            );

            if (req.status === 200) {
                if (req.data.type) {
                    if (submitted) {
                        toast.success('Exam saved successfully!');
                        this.setState({
                            shouldRedirect: true,
                            working: false,
                            examConfirm: {
                                ...this.state.examConfirm,
                                show: false,
                                action: () => { }
                            },
                            ExamAnswers: NewExamAnswers
                        });
                    } else {
                        this.setState({
                            working: false,
                        });
                    }
                } else {
                    toast.error(req.data.messageTitle + ' ' + req.data.message);
                    this.setState({
                        working: false,
                    });
                }
            }
        } catch (err) {
            toast.error('Something went wrong while saving exam!');
            this.setState({ working: false });
            console.log(err);
        }
    };


    saveExamAttemptQuestion = async (index) => {

        this.setState({ working: true });

        const { selectedChild, params } = this.props;
        const { exams_id, exam_retake_id } = params;
        const { class_id, child_id, parent_id } = selectedChild;

        let { ExamAnswers, examDetails } = this.state
        let Examsquest = examDetails.Examsquest
        let thisExamsquest = Examsquest[index]

        //  MCQs | True / False
        if (thisExamsquest.examsquesttype.eqtype_id == 1 || thisExamsquest.examsquesttype.eqtype_id == 3) {
            if (document.querySelector(`input[name="opt-${thisExamsquest.examsquest_id}"]:checked`)) {
                const id = document.querySelector(`input[name="opt-${thisExamsquest.examsquest_id}"]:checked`).getAttribute('data-id');
                const answer = document.querySelector(`input[name="opt-${thisExamsquest.examsquest_id}"]:checked`).value;
                ExamAnswers[index].examAns = [
                    {
                        ans_detail_id: 0,
                        exam_ans_id: 0,
                        examsquestoptions_id_selected: id,
                        examsquestoption: answer,
                        examsquestoptions_id_selected2: null,
                        examsquestoption2: null,
                    },
                ];
            }
        }
        // MRQ
        if (thisExamsquest.examsquesttype.eqtype_id == 2) {
            const mrq_answers = [];
            thisExamsquest.examsquestoptions.map((opt_item, opt_index) => {
                const opt_id = opt_item.examsquestoptions_id;
                if (document.querySelector(`#opt-${opt_id}:checked`)) {
                    const checkbox = document.querySelector(`#opt-${opt_id}:checked`);
                    mrq_answers.push({
                        ans_detail_id: 0,
                        exam_ans_id: 0,
                        examsquestoptions_id_selected: checkbox.getAttribute('data-id'),
                        examsquestoption: checkbox.value,
                        examsquestoptions_id_selected2: null,
                        examsquestoption2: null,
                    });
                }
            });
            ExamAnswers[index].examAns = mrq_answers;
        }

        //  Brief Description | Detailed Description
        if (thisExamsquest.examsquesttype.eqtype_id == 4 || thisExamsquest.examsquesttype.eqtype_id == 5) {
            const answer = document.getElementById(`brief-desc-${thisExamsquest.examsquest_id}`).value;
            ExamAnswers[index].answer = answer;
        }

        //  Fill In The Blank
        if (thisExamsquest.examsquesttype.eqtype_id == 8) {
            const fitb_answers = [];
            var elements = document.getElementsByClassName('fitb-' + thisExamsquest.examsquest_id);
            for (var i = 0, len = elements.length; i < len; i++) {
                fitb_answers.push({
                    ans_detail_id: 0,
                    exam_ans_id: 0,
                    examsquestoptions_id_selected: thisExamsquest.examsquestoptions[i].examsquestoptions_id,
                    examsquestoption: null,
                    examsquestoptions_id_selected2: thisExamsquest.examsquestoptions[i].examsquestoptions_id,
                    examsquestoption2: elements[i].value,
                });
            }
            ExamAnswers[index].examAns = fitb_answers;
        }

        const fData = new FormData();
        let thisExamAnswer = ExamAnswers[index]
        // UPLOAD FILE
        if (thisExamsquest.examsquesttype.eqtype_id == 7 && thisExamAnswer.attachment && thisExamAnswer.attachment.name) {
            fData.append('attachment[' + thisExamsquest.examsquest_id + ']', thisExamAnswer.attachment, thisExamAnswer.attachment.name)
        }
        fData.append('exams_id', exams_id);
        fData.append('class_id', class_id);
        fData.append('child_id', child_id);
        fData.append('parent_id', parent_id);
        fData.append('examAnswerData', JSON.stringify(thisExamAnswer));
        if (this.saveExamAttemptQuestionReq) { this.saveExamAttemptQuestionReq.abort(); }
        this.saveExamAttemptQuestionReq = new AbortController();
        try {
            const res = await POST('exam-attempt/save-exam-attempt-question', fData,
                {
                    signal: this.saveExamAttemptQuestionReq.signal,
                }
            );
            if (res) {
                let resData = res.data
                if (resData.type) {
                    this.setState({ working: false, ExamAnswers });
                } else {
                    this.setState({ working: false });
                    if (resData.data) {
                        handleFormErrors(resData.data)
                    } else {
                        toast[resData.messageType](resData.message);
                    }
                }
            }
        } catch (err) {
            toast.error('Something went wrong while saving exam question!');
            this.setState({ working: false });
            console.log(err);
        }
    }

    /**
     * Update Matching Words
     * @param {number} index
     * @param {array} data
     */
    updateMatchingWords = (index, data) => {
        console.log('updateMatchingWordsindex, data', index, data);

        const { authData } = this.props;
        const { center_id, center_timezone } = authData.centerData;
        const { examDetails, ExamAnswers } = this.state;
        const { Examsquest } = examDetails;
        const { examsquestoptions } = Examsquest[index];
        const matchingWords = [];
        for (var i = 0; i < examsquestoptions.length; ++i) {
            matchingWords.push({
                ans_detail_id: 0,
                exam_ans_id: 0,
                center_id: center_id,
                examsquestoptions_id_selected: examsquestoptions[i].examsquestoptions_id,
                examsquestoption: examsquestoptions[i].option_text,
                examsquestoptions_id_selected2: data[i].id,
                examsquestoption2: data[i].name,
            });
        }
        ExamAnswers[index].examAns = matchingWords;

        const { QsNums } = this.state;
        QsNums[index].status = 'attempted';

        this.setState({ ExamAnswers, QsNums }, () => {
            this.saveExamAttemptQuestion(index)
        });
    };

    /**
     * Upload Image
     * @param {number} qid
     * @param {number} index
     */
    uploadImage = (e, qid, index) => {
        const $this = this;
        const { ExamAnswers } = this.state;
        const file = document.querySelector('#file-' + qid).files[0];
        const selectedFiles = e.target.files;
        if (file) {
            var FR = new FileReader();
            FR.readAsDataURL(file);
            FR.addEventListener('load', function (e) {
                ExamAnswers[index].attachment = selectedFiles[0]
                // ExamAnswers[index].attachment = e.target.result.split(',')[1];
                $this.setState({ ExamAnswers }, () => $this.updateQNumStatus(index, 'attempted'));
            });
        }
    };

    /**
     * Hide / Show Qs Numbers
     */
    hideShowQList = () => {
        const { qListPanel } = this.state;
        this.qList.current.style.marginLeft = qListPanel ? '300px' : '0';
        this.qListNums.current.style.left = qListPanel ? '10px' : '-400px';
        this.setState({ qListPanel: !qListPanel });
    };

    /**
     * Render Questions Number
     * @returns {HTMLElement}
     */
    renderQsNums = () => {
        const { QsNums } = this.state;

        const qNums = QsNums.map((item, index) => {
            return (
                <button
                    key={index}
                    className={item.status}
                    onClick={() => this.scrollToQ(item.qid)}>
                    {index + 1}
                </button>
            );
        });

        return qNums;
    };

    /**
     * Update Question Number Status
     * @param {number} index
     * @param {string} status
     */
    updateQNumStatus = (index, status, event) => {
        let { ExamAnswers, examDetails } = this.state
        let Examsquest = examDetails.Examsquest
        if (Examsquest[index].eqtype_id == 2) {
            const isChecked = event.target.checked;
            if (isChecked) {
                if (ExamAnswers[index].examAns.length >= Examsquest[index].maxCorrectOptions) {
                    toast.error('Max ' + Examsquest[index].maxCorrectOptions + ' options can be selected!');
                    event.target.checked = false
                    return
                }
            }
        }

        const { QsNums } = this.state;
        QsNums[index].status = status;
        this.setState({ QsNums }, () => {
            if (status == 'attempted') {
                this.saveExamAttemptQuestion(index)
            }
        });
    };

    /**
     * Scroll To The Question
     * @param {string} qid
     */
    scrollToQ = (qid) => {
        document.getElementById('q-' + qid).scrollIntoView({
            behavior: 'smooth',
        });
    };

    /**
     * Render Component
     * @returns {HTMLElement}
     */
    render() {

        console.log('this.state', this.state);

        // Language Direction
        const { lang_orientation: dir } = this.props.defaultLanguage;
        let is_homework = (this.props.params.is_homework == 'true') ? true : false

        // State
        const { examDetails, examLocked, shouldRedirect, working, qListPanel } =
            this.state;

        if (shouldRedirect) {
            return <Navigate replace to={is_homework ? '/homework' : '/exams'} />;
        }

        return (
            <Container fluid>
                <div id='iedu-layout'>
                    <div id='page-content' style={{ paddingLeft: 0 }}>
                        <header
                            id='iedu-header'
                            className='pt-3'
                            style={{ overflow: 'hidden' }}>
                            <div className='d-flex flex-row align-items-center justify-content-between' style={{}}>
                                <div className='d-flex align-items-center me-2' style={{ flex: 1 }}>
                                    <div className='exam-title mb-0'>
                                        {examLocked !== null &&
                                            t(examLocked.messageTitle)}
                                        {examDetails !== null && (
                                            <>
                                                <img src={examTitleIcon} alt='' width='25' style={{ marginRight: 7 }} />
                                                {examDetails.Exams.exams_name}
                                            </>
                                        )}
                                    </div>
                                </div>
                                <div className='d-flex flex-row align-items-start justify-content-end me-0' style={{ flex: 2 }}>
                                    {examDetails !== null && (
                                        <>
                                            {(examDetails.Exams.exams_notes && examDetails.Exams.exams_notes != 'null') &&
                                                <div className='me-3 mb-0 d-flex align-items-center'
                                                    style={{ backgroundColor: '#fff', borderRadius: 35, padding: '5px 15px', }}>
                                                    <span className='me-2'>
                                                        <img
                                                            src={examNote}
                                                            alt=''
                                                            width='25'
                                                            style={{
                                                                marginRight: 7,
                                                            }}
                                                        />
                                                    </span>
                                                    <span style={{ fontSize: 12 }}>
                                                        {
                                                            examDetails.Exams
                                                                .exams_notes
                                                        }
                                                    </span>
                                                </div>
                                            }

                                            <Button variant='warning'
                                                disabled={working}
                                                onClick={() => this.saveExamAttempt()}
                                                style={{
                                                    borderRadius: 30,
                                                    minWidth: 80,
                                                    minHeight: 80,
                                                    marginLeft: 10,
                                                    fontWeight: 600,
                                                    fontSize: 14
                                                }}>
                                                {t('Save')}
                                            </Button>
                                            <Button variant='success'
                                                disabled={working}
                                                onClick={() =>
                                                    this.setState({
                                                        examConfirm: {
                                                            ...this.state.examConfirm,
                                                            show: true,
                                                            action: () => {
                                                                this.setState({
                                                                    examConfirm: {
                                                                        ...this.state.examConfirm,
                                                                        show: false
                                                                    }
                                                                });
                                                                this.saveExamAttempt(1);
                                                            }
                                                        }
                                                    })
                                                }
                                                style={{
                                                    borderRadius: 30,
                                                    marginLeft: 10,
                                                    minWidth: 80,
                                                    minHeight: 80,
                                                    fontWeight: 600,
                                                    fontSize: 14
                                                }}>
                                                {t('Save & Submit')}
                                            </Button>
                                        </>
                                    )}
                                    {examLocked !== null && (
                                        <button
                                            onClick={() => window.history.back()}
                                            style={{ borderRadius: 30, fontWeight: 700, textTransform: 'uppercase' }}
                                            className='btn btn-sm btn-primary px-3'>
                                            {t('Go Back')}
                                        </button>
                                    )}
                                </div>
                            </div>
                        </header>
                        {examDetails !== null ? (
                            <>
                                <button
                                    className='ql-btn'
                                    onClick={() => this.hideShowQList()}>
                                    <img
                                        src={qListPanel ? qlOpen : qlClose}
                                        alt=''
                                        width='35'
                                    />
                                </button>
                                <div
                                    className='q-list-nums'
                                    ref={this.qListNums}>
                                    <ExamTimeLeft
                                        dir={dir}
                                        examDetails={examDetails}
                                    />
                                    <h6
                                        className='text-center pb-2 mb-3'
                                        style={{
                                            borderBottom: '#9b9b9b 1px solid',
                                        }}>
                                        {t('Question List')}
                                    </h6>
                                    <div className='q-list-nums-grid'>
                                        {this.renderQsNums()}
                                    </div>
                                </div>
                                <div id='exam-qs' ref={this.qList}>
                                    <div className='grey-section'>
                                        {this.renderExamQs()}
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div
                                style={{
                                    height: '120px',
                                    flexDirection: 'column',
                                    width: '400px',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                }}
                                className='d-flex justify-content-center align-items-center text-center'>
                                {examLocked == null ? (
                                    <>
                                        <span className='mb-1'>
                                            <Spinner
                                                animation='grow'
                                                variant='dark'
                                            />
                                        </span>
                                        {is_homework ? t('Fetching homework...') : t('Fetching exam...')}
                                    </>
                                ) : (
                                    <>
                                        <span
                                            className='mb-1'
                                            style={{ fontSize: '30px' }}>
                                            <FontAwesomeIcon icon={faLock} />
                                        </span>
                                        {t(examLocked.message)}
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                {/* Exam Confirmation */}
                <SweetAlert show={this.state.examConfirm.show} warning showCancel confirmBtnText={t('Yes, submit it!')} confirmBtnBsStyle='success' title={t('Are you sure?')} onConfirm={this.state.examConfirm.action} onCancel={() => this.setState({ examConfirm: { show: false, action: () => { } } })
                } focusCancelBtn>
                    {t('Confirm Submit!')}
                </SweetAlert>
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    authData: state.auth.authData,
    selectedChild: state.selectedChild.data,
    languages: state.language.languages,
    defaultLanguage: state.language.defaultLanguage,
});
export default connect(mapStateToProps, null)(withParams(AttemptExam));

/***********************
 * EXTERNAL COMPONENTS *
 ***********************/

/**
 * Matching Words Component
 */
class MatchingWords extends Component {
    // State
    state = {
        list: null,
    };


    shuffleArray = (array) => {
        let ShuffleArray = JSON.parse(JSON.stringify(array))
        for (var i = ShuffleArray.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = ShuffleArray[i];
            ShuffleArray[i] = ShuffleArray[j];
            ShuffleArray[j] = temp;
        }

        return ShuffleArray;
    }

    /**
     * Component Did Mount
     */
    componentDidMount() {
        let list;

        if (this.props.answerOptions !== null) {
            list = this.props.answerOptions.map((item, index) => {
                return {
                    id: item.examsquestoptions_id_selected2,
                    name: item.examsquestoption2,
                    option_text_picture: item.examsquestoption2_picture
                };
            });
        } else {
            list = this.shuffleArray(this.props.opts).map((item, index) => {
                return {
                    id: item.examsquestoptions_id,
                    name: item.option_value,
                    option_text_picture: item.option_text_picture
                };
            });
        }

        this.setState({ list });
    }

    /**
     * Render Component
     * @returns {HTMLElement}
     */
    render() {
        const { list } = this.state;

        if (list == null) return;

        return (
            <ReactSortable
                animation={200}
                delayOnTouchStart={true}
                delay={2}
                list={list}
                setList={(list) => {
                    this.setState({ list });
                    this.props.updateMatchingWords(this.props.index, list);
                }}>
                {list.map((item, index) => (
                    <div key={index} className='word-to-match position-relative'>
                        <div style={{ border: 'solid 1px #e7e7e7', borderRadius: 30, padding: 5 }}>{(index + 1)}</div>
                        <div className='d-flex flex-column ps-2' style={{ flex: 1 }}>
                            {item.option_text_picture && (
                                <div>
                                    <img
                                        src={`${getRegionalStorageURL(this.props.authData.centerData.tenant_id) + this.props.authData.centerData.center_uuid}/examsquestoptions/${item.option_text_picture}`}
                                        alt={item.option_text}
                                        style={{ maxWidth: '200px', maxHeight: '150px', display: 'block', marginBottom: '5px' }}
                                    />
                                </div>
                            )}
                            <div dangerouslySetInnerHTML={{ __html: item.name }} />
                            {/* <div className='mx-1'>{item.name}</div> */}
                        </div>
                        <FontAwesomeIcon icon={faBars} color='#cdcdcd' />
                    </div>
                ))}
            </ReactSortable>
        );
    }
}

class ExamTimeLeft extends Component {
    // State
    state = {
        examHoursLeft: 0,
        examMinsLeft: 0,
        examSecsLeft: 0,
    };

    /**
     * Component Did Mount
     */
    componentDidMount() {
        const interval = setInterval(() => this.examRemainingTime(), 1000);
        return () => clearInterval(interval);
    }

    /**
     * Exam Remaining Time Clock
     */
    examRemainingTime = () => {
        const { examDetails } = this.props;
        const { Exams } = examDetails;
        const { exams_date, close_time } = Exams;
        const examEndingDatetime = Date.parse(
            exams_date + ' ' + close_time + ':00'
        );
        const timeLeft = examEndingDatetime - Date.now();
        this.setState({
            examHoursLeft: Math.floor((timeLeft / (1000 * 60 * 60)) % 24),
            examMinsLeft: Math.floor((timeLeft / 1000 / 60) % 60),
            examSecsLeft: Math.floor((timeLeft / 1000) % 60),
        });
    };

    /**
     * Render Component
     * @returns {HTMLElement}
     */
    render() {
        const { examHoursLeft, examMinsLeft, examSecsLeft } = this.state;

        return (
            <div
                style={{
                    display: 'flex',
                    fontSize: '12px',
                    alignItems: 'center',
                    borderRadius: 35,
                    border: 'solid 1px #ccc',
                    padding: 10,
                    width: '100%'
                }}
                className={'mb-2'}>
                <img src={timeLeft} alt='' width='25' className='me-2' />
                <span className='ms-1'>
                    <strong>{t('Time Remaining:')}</strong>
                    <br />
                    <span
                        style={{
                            color: '#EE3A81',
                            fontWeight: '400',
                        }}>
                        {' ' +
                            examHoursLeft +
                            ' ' +
                            t('H') +
                            ', ' +
                            examMinsLeft +
                            ' ' +
                            t('M') +
                            ', ' +
                            examSecsLeft +
                            ' ' +
                            t('S')}
                    </span>
                </span>
            </div>
        );
    }
}
